// Department (SPD / LCV / future) helpers. See DEPT_CODE_MASTER_GUIDE.md
// No dept_code in the URL = SPD = existing behaviour.

// Returns dept_code from the current URL query (e.g. ?dept_code=LCV), or '' when absent
var getDeptCode = function() {
    try {
        var deptCode = new URLSearchParams(window.location.search).get("dept_code");
        return (deptCode) ? deptCode.trim().toUpperCase() : '';
    }
    catch (e) {
        return '';
    }
}
exports.getDeptCode = getDeptCode;

// Appends ?dept_code=<code> to a menu path only when the menu record has a dept_code
var getDeptMenuPath = function(path, deptCode) {
    if (deptCode == '' || deptCode == undefined || deptCode == null) {
        return path;
    }
    var separator = (String(path).indexOf("?") >= 0) ? "&" : "?";
    return path + separator + "dept_code=" + encodeURIComponent(deptCode);
}
exports.getDeptMenuPath = getDeptMenuPath;

// Adds dept_code to a request body only on LCV / other dept pages; SPD pages get the body back unchanged
var withDeptCode = function(body) {
    var deptCode = getDeptCode();
    if (deptCode == '') {
        return body;
    }
    return Object.assign({}, body, { dept_code: deptCode });
}
exports.withDeptCode = withDeptCode;
